import { useQueryParams } from '@fs/zion-router'

const VALID_VALUES = new Set(['simple', 'advanced'])

/**
 * Reads the `searchForm` query param that full-text search results append to viewer
 * links (FSS-14808), identifying which search form (simple or advanced) led the user
 * here so attach/download analytics can be attributed to it.
 *
 * @returns {'simple'|'advanced'|undefined} the validated form type, or undefined when
 *   the param is absent or not a recognized value
 */
export default function useSearchFormParam() {
  const { query } = useQueryParams()
  return VALID_VALUES.has(query.searchForm) ? query.searchForm : undefined
}
